// LoginForm.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { trackEvent, EVENTS } from '../utils/analytics';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, signInWithGoogle } = useContext(AuthContext);
  const navigate = useNavigate();
    
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    try {
      await login(email, password);
      trackEvent(EVENTS.LOGIN, { 
        method: 'email'
      });
      navigate('/portfolio');
    } catch (err) {
      switch (err.code) {
        case 'auth/user-not-found':
          setError('Kein Konto mit dieser E-Mail gefunden');
          break;
        case 'auth/wrong-password':
          setError('Falsches Passwort');
          break;
        case 'auth/too-many-requests':
          setError('Zu viele fehlgeschlagene Versuche. Bitte versuch es später erneut');
          break;
        default:
          setError('Beim Login ist ein Fehler aufgetreten');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
      navigate('/portfolio');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="login-form">
      {error && (
        <div className="error-message">
          <i className="fas fa-exclamation-circle"></i>
          {error}
        </div>
      )}

      <div className="social-login">
        <button 
          type="button" 
          onClick={handleGoogleSignIn} 
          className="google-signin-btn"
        >
          <div className="google-signin-content">
            <img 
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4="
              alt="Google" 
            />
            <span>Sign in with Google</span>
          </div>
        </button>
      </div>
      
      <hr style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #dadce0' }} />
      
      <div className="form-group">
        <label>E-Mail-Adresse</label>
        <div className="input-group">
          <span className="input-group-text">
            <i className="fas fa-envelope"></i>
          </span>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Gib deine E-Mail ein"
            required
          />
        </div>
      </div>

      <div className="form-group">
        <div className="password-header">
          <label>Passwort</label>
          <a href="/forgot-password" className="forgot-link">Passwort vergessen?</a>
        </div>
        <div className="input-group">
          <span className="input-group-text">
            <i className="fas fa-lock"></i>
          </span>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Gib dein Passwort ein"
            required
          />
        </div>
      </div>

      <button 
        type="submit" 
        className={`login-button ${isLoading ? 'loading' : ''}`}
        disabled={isLoading}
      >
        {isLoading ? (
          <span className="loading-spinner">
            <i className="fas fa-spinner fa-spin"></i>
          </span>
        ) : (
          'Einloggen'
        )}
      </button>

      <div className="register-prompt">
        Du hast noch kein Konto? <a href="/register">Hier erstellen</a>
      </div>
    </form>
  );
}

export default LoginForm;